import useSFAnimation from "../animation";
import AnimatedLogo from "./logoAnimated.json";

export const SFLogo = () => {
  const LogoAnimation = useSFAnimation({
    animation: AnimatedLogo,
    loop: false,
    autoplay: true,
    style: { width: 480 },
  });
  
  return LogoAnimation;
};
